export * from './models';
export { newRequestID } from '@mastery/http-client';
export { APIError, guardSession, request } from './request';
import { request } from './request';
export const api = {
  get: <T>(path: string, options: RequestInit = {}) => request<T>('/api/v1' + path, options),
  post: <T>(path: string, body: unknown = {}, headers: Record<string, string> = {}) =>
    request<T>('/api/v1' + path, { method: 'POST', body: JSON.stringify(body), headers }),
  put: <T>(path: string, body: unknown) =>
    request<T>('/api/v1' + path, { method: 'PUT', body: JSON.stringify(body) }),
  patch: <T>(path: string, body: unknown) =>
    request<T>('/api/v1' + path, { method: 'PATCH', body: JSON.stringify(body) }),
  upload: (file: Blob, filename = 'recording.webm') => {
    const form = new FormData();
    form.append('file', file, filename);
    return request<import('./models').MediaFile>('/api/v1/media', { method: 'POST', body: form });
  },
};
